import React from "react";
import PattayaFirstLoad from "./functions/Pattaya.FirstLoad";
import PattayaBanner from "./render/Pattaya.Banner";
import PattayaList from "./render/Pattaya.List";
import MetaTags from "../../utils/useMetaTags";
import { ContextLanguage } from "../../context/Context.Language";

const PattayaMain = ({ programs, addons }) => {
  React.useEffect(() => {
    PattayaFirstLoad();
  }, []);

  const { language } = React.useContext(ContextLanguage);
  if (programs && addons) {
    return (
      <div id="scroll_pattaya">
        {language === "TH" ? (
          <MetaTags
            title="ที่ตั้ง - พัทยา | My Laundry"
            description="เราให้บริการซักรีดและทำความสะอาดรองเท้าอย่างมืออาชีพในพื้นที่ส่วนใหญ่ของพัทยา พร้อมส่งฟรีภายใน 12:00 น. ของวันถัดไป จองตอนนี้เลย!"
          />
        ) : (
          <MetaTags
            title="Locations - Pattaya | My Laundry"
            description="Our professional laundry service & shoe cleaning service is available nearly everywhere in Pattaya! Enjoy FREE next-day delivery by 12:00! Book now!"
          />
        )}
        <PattayaBanner />
        <PattayaList programs={programs} data={addons} />
      </div>
    );
  } else {
    return null;
  }
};

export default PattayaMain;
